<script>
import VectorLayer from 'ol/layer/Vector'
import parseStyle from '../ol-map/utils/style'

// 图形样式
const defaultEffect = {
  fill: 'rgba(90, 200, 33, 0.2)',
  stroke: {
    color: '#5ac821', // 绿色
    width: 2
  }
}

let olMap = null

export default {
  name: 'ol-layer-vector',

  inject: ['getMap'],

  render () {
    return this.$slots.default
  },

  provide () {
    return {
      getLayer: this.getLayer
    }
  },

  props: {
    // 图层名称
    name: {
      type: String,
      default: ''
    },

    // 图层类型
    type: {
      type: String,
      default: ''
    },

    // 是否可见
    visible: {
      type: Boolean,
      default: true
    },

    // 透明度（0~1）
    opacity: {
      type: Number,
      default: 1
    },

    // 层级
    zIndex: {
      type: Number,
      default: undefined
    },

    // 图形样式
    effect: {
      type: [Object, Function],
      default () {
        return defaultEffect
      }
    }
  },

  watch: {
    visible (visible) {
      this.vectorLayer.setVisible(visible)
    },

    zIndex (zIndex) {
      this.vectorLayer.setZIndex(zIndex)
    }
  },

  data () {
    return {
      vectorLayer: null
    }
  },

  created () {
    this.vectorLayer = new VectorLayer({
      name: this.name,
      type: this.type,
      visible: this.visible,
      zIndex: this.zIndex,
      opacity: this.opacity,
      style: parseStyle({ ...defaultEffect, ...this.effect })
    })

    this.getMap(map => {
      olMap = map
      map.addLayer(this.vectorLayer)
    })
  },

  methods: {
    // 获取组件实例
    getLayer (cb) {
      cb(this.vectorLayer)
    }
  },

  beforeDestroy () {
    olMap.removeLayer(this.tileLayer)
    this.vectorLayer = null
  }
}
</script>
